import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { COMMON_CONSTANTS } from '../common/core/common.constants';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  param = undefined;

  constructor() { 
    //tslint:disable:no-empty
    //@ts-ignore
  }

  private sharedData = new BehaviorSubject<any>(COMMON_CONSTANTS.HANDSHAKE_ERROR_MSG);
  shareData = this.sharedData.asObservable();
  private dataSourceGeneric = new BehaviorSubject(this.param);
  currentDataGeneric = this.dataSourceGeneric.asObservable();

  sendData(data: any) {
    this.sharedData.next(data);
  }
  sendDataGeneric(data: Map<string, any>) {
    this.dataSourceGeneric.next(data);
  }

}
